<div class="add-button-overlay" [style.z-index]="zIndex" *ngIf="visible"></div>
